import { useToolCatalog } from "~/pages/manifold-nextgen/components/conversations/useToolCatalog";
import type { ToolCallEntry } from "~/pages/manifold-nextgen/components/conversations/useTurns";

interface PlatformActivityProps {
  entries: ToolCallEntry[];
}

// The live status line above a running turn, naming the tool in use. Every
// platform tool is a read, so there is nothing worth disclosing after the fact.
export function PlatformActivity({ entries }: PlatformActivityProps) {
  const { resolveTool } = useToolCatalog();
  const latest = entries[entries.length - 1];
  const tool = latest ? ` (${resolveTool(latest.name).displayName})` : "";

  return (
    <p className="shimmer-text px-3 text-xs" role="status">
      Thinking{tool}…
    </p>
  );
}
